import styled, { css } from "styled-components";

export const Form = styled.form`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;

    @media only screen and (max-width: 600px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
`;

export const Label = styled.label`
    display: flex;
    margin-bottom: 5px;
`;

export const FieldContainer = styled.div`
    ${(props) =>
        props?.$fullcol &&

        css`
                grid-column: span 2 / span 2;
                display: flex;
                flex-direction: column;
                align-items: start;
                justify-content: start;

                @media only screen and (max-width: 600px) {
                    grid-column: span 1 / span 1;
                }
            `
    }`;

export const ActionsContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
`;

export const FormError = styled.p`
    color: var(--color-error);
    font-size: 11px;
    padding-top: 2px;
`;